import React, { useCallback, useState } from "react";
import { ProformaEmployeeCostReportDTO } from "../../models/proforma-employee-cost-report/proforma-employee-cost-report-dto";
import { CompanyLegalEntityDTO } from "../../models/company-accounts/company-legal-entities";

import ProformaEmployeeCostReport from "./ProformaEmployeeCostReport/ProformaEmployeeCostReport";
import { Alert, Dialog, DialogContent } from "@mui/material";
import DialogTitle from "../../containers/DialogTitle/DialogTitle";
import AddEditButton from "../../reusable-components/AddEditButton/AddEditButton";
import ConfirmationChangesDialog from "../../containers/ConfirmationChangesDialog/ConfirmationChangesDialog";
import EmployeeCostReportGuide from "./EmployeeCostReportGuide";
import { useTranslation } from "react-i18next";

export interface Props {
  effect: "add" | "edit";
  customButtonStyle?: React.CSSProperties;
  item?: ProformaEmployeeCostReportDTO;
  legalEntity?: CompanyLegalEntityDTO;
  handleNotifyParent?: () => void;
  handleCloseParent: () => void;
}
interface State {
  open: boolean;
  CCDOpen: boolean;
}

const AddEditProformaEmployeeCostReport = ({
  effect,
  customButtonStyle,
  item,
  legalEntity,
  handleNotifyParent,
  handleCloseParent,
}: Props) => {
  const { t } = useTranslation();
  const tRP = "components.add_edit_proforma_employee_cost_report";

  const [state, setState] = useState<State>({
    open: false,
    CCDOpen: false,
  });

  const handleDiscard = useCallback(() => {
    setState((state) => ({
      ...state,
      CCDOpen: false,
      open: false,
    }));
  }, []);

  return (
    <>
      <AddEditButton
        effect={effect}
        title={`${
          effect === "add"
            ? `${t(`${tRP}.add_title`)}`
            : item?.isAcceptedByClient
            ? `${t(`${tRP}.view_title`)}`
            : `${t(`${tRP}.edit_title`)}`
        }`}
        {...(effect === "edit" && {
          buttonText: item?.isAcceptedByClient ? `${t(`buttons.view`)}` : `${t(`buttons.edit`)}`,
        })}
        onClick={() => setState((state) => ({ ...state, open: true }))}
        customStyle={customButtonStyle}
      />
      <Dialog
        open={state.open}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle
          title={`${
            effect === "add"
              ? `${t(`${tRP}.add_title`)}`
              : item?.isAcceptedByClient
              ? `${t(`${tRP}.view_title`)}`
              : `${t(`${tRP}.edit_title`)}`
          }`}
          handleClose={() => setState((state) => ({ ...state, CCDOpen: true }))}
          additionalButtons={<EmployeeCostReportGuide />}
        />
        <DialogContent>
          {item?.isAcceptedByClient && <Alert severity="info">{`${t(`${tRP}.already_accepted_by_client`)}`}</Alert>}
          <br />
          <ProformaEmployeeCostReport
            effect={effect}
            item={item}
            legalEntity={legalEntity}
            handleNotifyParent={handleNotifyParent}
            handleDiscard={handleDiscard}
            handleCloseParent={() => setState((state) => ({ ...state, open: false }))}
          />
        </DialogContent>
      </Dialog>
      <ConfirmationChangesDialog
        open={state.CCDOpen}
        handleCancel={() => setState((state) => ({ ...state, CCDOpen: false }))}
        handleDiscard={handleDiscard}
      />
    </>
  );
};

export default AddEditProformaEmployeeCostReport;
